<template>
  <v-layout row>
    <v-toolbar app>
      <v-toolbar-items>
        <v-btn flat to="/">Главная</v-btn>
        <v-btn flat to="/addresses">Адреса секций</v-btn>
        <v-btn flat to="/coaches">Тренеры</v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </v-layout>
</template>

<script>
export default {};
</script>

<style>
</style>
